import axios from 'axios';
import { message } from 'antd';

const handleUnauthorized = (messageText) => {
  const hint = messageText || '登录已过期，请重新登录';
  message.error(hint);
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  window.location.href = '/login';
};

// 创建axios实例
const api = axios.create({
  baseURL: '/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 添加认证token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 添加请求ID
    config.headers['X-Request-ID'] = Date.now().toString();
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    const { data } = response;
    
    // 统一处理响应格式
    if (data.code === 200) {
      return data;
    }

    if (data.code === 10002) {
      handleUnauthorized(data.message);
      return Promise.reject(new Error(data.message || '未授权访问'));
    }

    message.error(data.message || '请求失败');
    return Promise.reject(new Error(data.message || '请求失败'));
  },
  (error) => {
    const { response } = error;
    
    if (response) {
      const { status, data } = response;
      
      if (data?.code === 10002) {
        handleUnauthorized(data.message);
        return Promise.reject(new Error(data.message || '未授权访问'));
      }

      switch (status) {
        case 401:
          handleUnauthorized(data?.message);
          break;
        case 403:
          message.error('没有权限访问');
          break;
        case 404:
          message.error('接口不存在');
          break;
        case 422:
          message.error(data.message || '参数验证失败');
          break;
        case 500:
          message.error('服务器内部错误');
          break;
        default:
          message.error(data.message || '请求失败');
      }
    } else {
      message.error('网络连接失败');
    }
    
    return Promise.reject(error);
  }
);

// 便捷方法
export const get = async (url, params = {}, method = 'GET') => {
  const config = { method: method.toLowerCase(), url };
  if (params && Object.keys(params).length > 0) {
    if (method === 'GET' || method === 'DELETE') {
      config.params = params;
    } else {
      config.data = params;
    }
  }
  return api(config);
};

export const post = async (url, data = {}) => {
  return api.post(url, data);
};

export const put = async (url, data = {}) => {
  return api.put(url, data);
};

export const postJson = async (url, data = {}) => {
  return api.post(url, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const del = async (url, params = {}) => {
  return api.delete(url, { params });
};

export default api;
